<template>
  <div
    v-if="loading"
    class="ma-5 text-xs-center"
  >
    <v-progress-circular
      indeterminate
      :size="32"
      color="accent"
    />
  </div>
  <div
    v-else
    layout="column"
  >
    <v-tabs
      v-model="tab"
      align-with-title
      @change="fetch"
    >
      <v-tabs-slider color="#f4b944" />
      <v-tab
        key="daggesrapport"
      >
        Daggesrapports
      </v-tab>
      <v-tab
        key="individual"
      >
        Individual evaluations
      </v-tab>
      <v-tab
        v-if="$route.params.sessionType == Consts.SCHOOL"
        key="teacher"
      >
        Teacher evaluations
      </v-tab>
    </v-tabs>
    <div
      layout="row"
      class="subheading font-weight-light ml-2 my-2"
    >
      {{ evals.nb_evals }} evaluation{{ evals.nb_evals > 1 ? 's' : '' }} / {{ evals.nb_evals_expected }} expected
    </div>
    <div
      v-if="evals && evals.evals_stats && evals.evals_stats != {}"
      layout-gt-md="row"
      layout-align="start stretch"
      layout-wrap
    >
      <div
        v-for="(t, f) in evals.evals_stats"
        :key="f"
        layout="column"
        :flex="t.content && Object.values(t.content).length ? 100 : 50"
        class="mb-4"
      >
        <div
          v-if="t.content && Object.values(t.content).length"
          layout="row"
        >
          <v-expansion-panel>
            <v-expansion-panel-content>
              <div slot="header">
                {{ f }} (answers: {{ t.nb }})
              </div>
              <v-card>
                <v-card-text>
                  <div
                    v-for="(comm,id) in t.content"
                    :key="id + f"
                    layout="row"
                  >
                    <div
                      layout="column"
                      flex="20"
                    >
                      Session #{{ id }}
                    </div>
                    <div
                      layout="column"
                      flex
                    >
                      {{ comm }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
        <template v-else>
          <div
            layout="row"
            class="subheading"
          >
            {{ f }} (answers: {{ t.nb }}, average: {{ t.average.toFixed(2) }})
          </div>
          <div
            v-for="i in (0,5)"
            :key="'mark'+i + f"
            layout="row"
          >
            <div
              layout="column"
              flex="5"
              class="mt-2"
            >
              {{ i }} :
            </div>
            <div
              layout="column"
              flex="70"
            >
              <v-progress-linear
                v-model="t['percent_' + i]"
                height="14"
                color="primary"
              />
            </div>
            <div
              layout="column"
              flex
              class="mt-2 ml-2"
            >
              {{ t[i] }} answer{{ t[i] > 1 ? 's' : '' }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Statistics from '@/api/statistics'
import Consts from '@/consts'

export default {
  props: ['start', 'end', 'application', 'toFilter'],
  data () {
    return {
      evals: {
        evals_stats: {}
      },
      loading: false,
      tab: 0,
      Consts
    }
  },
  watch: {
    '$route.params.sessionType': function () {
      if(this.tab == 2){
        this.tab = 0
      }

      this.fetch()
    },
    toFilter (val) {
      if (val) {
        this.fetch()
        this.$emit('update:toFilter', false)
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      Statistics.getEvals({ start: this.start, end: this.end, application: this.application, data_type: this.tab, session_type: this.$route.params.sessionType }).then(res => {
          this.evals = res.data
          this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.number-color {
  color: #f4b944;
}
</style>
